// @flow

import * as React from 'react';

import type { Actions } from '../../../types';
import ActionsColumn from '../../../components/ActionsHeaderColumn';
import ActivateOrderAction from '../../../components/actions/ActivateOrderAction';
import { MobileView } from '../../../config/mediaQuery';

type Props = {
  minHeight: string,
  clearCollectionAndResetChangedOrderItems: () => mixed
};

const ActionsOrganizer = (props: Actions & Props) => {
  const {
    CopyAction,
    ExportAction,
    getGlobalDisabledState,
    loading,
    onOrderActivated,
    orderActiveStatus,
    currentItem,
    displayRowMenu,
    displayMenu
  } = props;

  return (
    <>
      <MobileView>
        <div className='action-menu-items'>
          <ActionsColumn>
            <table>
              {displayMenu &&
                <tbody>
                  <tr>
                    <td><ExportAction /></td>
                  </tr>
                </tbody>
              }
              {displayRowMenu &&
                <tbody>
                  <tr>
                    <td><CopyAction /></td>
                    <td>
                      {!currentItem.Active &&
                        <ActivateOrderAction
                          disabled={getGlobalDisabledState() || loading}
                          onOrderActivated={onOrderActivated}
                          orderActiveStatus={orderActiveStatus}
                          item={currentItem}
                          onMutationCompleted={() => {}}
                        />
                      }
                    </td>
                  </tr>
                  <tr>
                    <td><ExportAction /></td>
                  </tr>
                </tbody>
              }
            </table>
          </ActionsColumn>
        </div>
      </MobileView>
    </>
  );
};

export default ActionsOrganizer;
